import { Model } from 'core/models';

export class Sex extends Model {
    public id?: number;
    public code?: string;
    public name?: string;
}
